/**
 * useCurrentUser Hook
 * Fetches current authenticated user using TanStack Query
 */

import { useQuery } from '@tanstack/react-query'
import { authRepo } from '@/lib/repositories'
import type { User } from '@/lib/repositories/interfaces/IAuthRepository'

export const CURRENT_USER_QUERY_KEY = ['currentUser'] as const

export function useCurrentUser() {
  return useQuery<User | null, Error>({
    queryKey: CURRENT_USER_QUERY_KEY,
    queryFn: () => authRepo.getCurrentUser(),
    staleTime: 5 * 60 * 1000, // 5 minutes (user changes infrequently)
  })
}
